import React from 'react';
import { getClassNameFactory, getRehydratableName } from '@dcl/ui';
import { propsToDataAttributes } from '@tr-digital/react-rehydrate';
import { IBadgeProps } from './types';
import './index.css';

export const Badge: React.FC<IBadgeProps> = (props) => {
  const { badge } = props;

  const getClassName = getClassNameFactory(Badge.displayName);

  return (
    <div
      data-rehydratable={getRehydratableName(Badge.displayName)}
      {...propsToDataAttributes(props)}
      className={getClassName()}
    >
      <span>{badge}</span>
    </div>
  );
};

Badge.displayName = 'Badge';
